import { render, staticRenderFns } from "./crudOrdersReason.vue?vue&type=template&id=41f9cf63&"
import script from "./crudOrdersReason.vue?vue&type=script&lang=js&"
export * from "./crudOrdersReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports